import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './hooks/useAuth'
import Layout from './components/Layout'
import LoginPage from './pages/Login'
import Dashboard from './pages/Dashboard'
import Courses from './pages/Courses'
import CourseDetail from './pages/CourseDetail'
import Exams from './pages/Exams'
import ExamTaking from './pages/ExamTaking'
import LiveClass from './pages/LiveClass'
import Certificates from './pages/Certificates'
import AdminPanel from './pages/AdminPanel'
import AIAssistant from './pages/AIAssistant'
import RandomQuizPopup from './components/RandomQuizPopup'
import ProctoringOverlay from './components/ProctoringOverlay'
import SubscriptionManager from './pages/SubscriptionManager'
import SecurityCenter from './pages/SecurityCenter'

function App() {
  const { user, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <LoginPage />
  }

  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<CourseDetail />} />
          <Route path="/exams" element={<Exams />} />
          <Route path="/exams/:id/take" element={<ExamTaking />} />
          <Route path="/live-class/:id" element={<LiveClass />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/ai-assistant" element={<AIAssistant />} />
          <Route path="/subscriptions" element={<SubscriptionManager />} />
          <Route path="/security" element={<SecurityCenter />} />
          {user.role === 'admin' && (
            <Route path="/admin/*" element={<AdminPanel />} />
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
      <RandomQuizPopup />
      <ProctoringOverlay />
    </>
  )
}

export default App
